/**
 * EffectPassWrapper - manages EffectPass from postprocessing library.
 */

import { EffectPass } from 'postprocessing';

import type { Constructor } from '../../../systems/ClassRegistry.js';
import type { Effect } from 'postprocessing';
import type * as THREE from 'three';
export class EffectPassWrapper {
  private effects: Effect[];
  private pass: EffectPass;

  constructor(camera: THREE.Camera, effects: Effect[]) {
    this.effects = effects;
    this.pass = new EffectPass(camera, ...this.effects);
    this.pass.enabled = false;
  }

  public getEffect<T extends Effect>(type: Constructor<T>): T | null {
    return this.effects.find(effect => effect instanceof type) as T | null;
  }

  public getEffects(): Effect[] {
    return this.effects;
  }

  public getPass() {
    return this.pass;
  }

  public enableEffect() {
    this.pass.enabled = true;
  }

  public disableEffect() {
    this.pass.enabled = false;
  }

  public resize(width: number, height: number): void {
    for (const effect of this.effects) {
      effect.setSize(width, height);
    }
    this.pass.setSize(width, height);
  }

  public dispose() {
    for (const effect of this.effects) {
      effect.dispose();
    }
  }
}